'use strict';

var chunkUPFVNSZC_js = require('./chunk-UPFVNSZC.js');

function l(){sessionStorage.clear(),localStorage.clear(),chunkUPFVNSZC_js.c();}

exports.a = l;
